<script>
	import whyUsBg from '$ravioli/lib/assets/images/section-bg.png';
	import personalTrainer from '$ravioli/lib/assets/icons/personal-trainer.svg';
	import truck from '$ravioli/lib/assets/icons/truck.svg';
	import dish from '$ravioli/lib/assets/icons/dish.svg';
	import user from '$ravioli/lib/assets/icons/user.svg';
	let whyUsItems = [
		{ icon: personalTrainer, title: 'Certified nutritionist & fitness expert' },
		{ icon: truck, title: 'Doorstep delivery fresh every day' },
		{ icon: dish, title: 'Ravioli fit meals' },
		{ icon: user, title: 'Support to stay on track' }
	];
</script>

<section class="bg-why-us font-roboto px-4 py-11 md:py-12" style="background-image:url('{whyUsBg}') ;">
	<p class="title-underline relative mx-auto max-w-fit text-xl font-medium uppercase md:text-2xl">
		Why choose us?
	</p>
	<ul
		class="mx-auto mt-8 grid w-full max-w-max grid-cols-1 gap-8 md:mt-10 md:gap-11 lg:grid-cols-2"
	>
		{#each whyUsItems as item}
			<li class="flex items-center gap-3 md:gap-6">
				<div
					class="flex aspect-square h-[50px] w-[50px] items-center justify-center overflow-hidden rounded-full bg-[#FCF6ED] md:h-16 md:w-16"
				>
					<img src={item.icon} alt={item.title} class="md:w-10" />
				</div>
				<p class="md:font-medium">{item.title}</p>
			</li>
		{/each}
	</ul>
</section>

<style>
	.bg-why-us {
		/* background-image: url('{whyUsBg}'); */
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}
</style>
